module.exports = "<div class=\"mdl-layout mdl-js-layout\">\n  <main class=\"mdl-layout__content\">\n    <router-outlet></router-outlet>\n  </main>\n</div>\n"